<template>
	<v-dialog
		v-model="ui.dialog"
		persistent
		:width="$vuetify.breakpoint.smAndDown ? '100%' : '800px'"
	>
		<v-card :class="[$vuetify.breakpoint.smAndDown ? 'pa-2' : 'pa-4']">
			<v-card-title>
				Nuevo cliente
			</v-card-title>
			<v-card-text class="pb-0">
				<v-form ref="form" v-model="ui.valid" lazy-validation>
					<v-row>
						<v-col cols="12" md="4" class="pb-0">
							<v-text-field
								clearable
								label="Id NetSuite"
								v-model="layout.id"
								outlined
								autocomplete="off"
								dense
								:rules="[v.required, v.integer]"
							></v-text-field>
						</v-col>

						<v-col cols="12" md="4" class="pb-0">
							<v-text-field
								clearable
								label="Folio"
								v-model="layout.folio"
								outlined
								dense
								:rules="[v.required, v.integer]"
							></v-text-field>
						</v-col>

						<v-col cols="12" md="4" class="pb-0">
							<v-text-field
								clearable
								label="Nombre"
								v-model="layout.name"
								outlined
								dense
								:rules="[v.required]"
							></v-text-field>
						</v-col>

						<v-col cols="12" md="4" class="pb-0">
							<v-text-field
								clearable
								label="RFC"
								v-model="layout.rfc"
								outlined
								dense
								:rules="[v.required, v.rfc]"
							></v-text-field>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click="ui.dialog = false" :disabled="ui.storing">
					Cancelar
				</v-btn>
				<v-btn color="primary" @click="store()" :loading="ui.storing">
					Enviar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { EventBus } from "@/main";
import { V } from "@/main";
import axios from "axios";
import { mapState } from "vuex";

export default {
	data() {
		return {
			v: V,

			layout: {
				id: null,
				rfc: null,
				name: null,
				folio: null,
			},

			ui: {
				valid: true,
				dialog: false,
				storing: false,
			},
		};
	},
	mounted() {
		EventBus.$on("CustomerCreate", () => {
			this.ui.dialog = true;
		});
	},

	methods: {
		async store() {
			if (this.$refs.form.validate()) {
				this.ui.storing = true;

				try {
					let response = await axios.post(
						`${process.env.VUE_APP_API_SERVER}/auth/store/customer`,
						this.layout,
						{
							headers: {
								Authorization: `Bearer ${this.acount.token}`,
							},
						}
					);

					this.ui.dialog = false;

					this.$refs.form.reset();

					EventBus.$emit("CustomerCreated", response.data.data);

					this.$store.dispatch("setCustomer", response.data.data);
				} catch (error) {
					EventBus.$emit("Error", { error: error, errorsShow: true });
				} finally {
					this.ui.storing = false;
				}
			}
		},
	},

	computed: {
		...mapState(["acount"]),
	},
};
</script>
